import CardContainer from 'src/components/CardContainer/CardContainer';
import { KnowledgeBases } from 'src/pages/ControlDeskPage/DataSourceSection/KnowledgeBases/KnowledgeBases';
import { clsx } from 'clsx';
import { useParams } from 'react-router-dom';
import { useGetAllConfigurationSettingsQuery, useGetProjectByIdQuery } from 'src/services';
import { useAppSelector } from 'src/store';
import { getApiVersion } from 'src/utils/apiVersion';
import { API_VERSION } from 'src/constants/api-routes';
import { useEffect, useState } from 'react';
import { Skeleton } from 'src/components/ui/skeleton';
import { CustomConfigurationMessage } from 'src/components/CustomConfigurationMessage/CustomConfigurationMessage';

export const DataSourceSection = () => {
  const { isInactivePlan } = useAppSelector((s) => s.planSlice);
  const { id } = useParams();
  const [isCustomSettings, setIsCustomSettings] = useState<boolean>(false);
  const version = getApiVersion();
  const isV2 = version === API_VERSION.V2;
  const { data: allConfigurationSettings, isLoading: isLoadingAllConfigurationSettings } =
    useGetAllConfigurationSettingsQuery(
      { id },
      { skip: !id || !isV2, refetchOnMountOrArgChange: true },
    );
  const { data: currentProject } = useGetProjectByIdQuery({ id: id });

  useEffect(() => {
    if (allConfigurationSettings) {
      const isCustom = Boolean(
        allConfigurationSettings.items.find((item) => item.is_deployed)?.is_custom,
      );

      setIsCustomSettings(isCustom);
    }
  }, [allConfigurationSettings]);

  const renderContent = () => {
    if (isLoadingAllConfigurationSettings) {
      return (
        <div className={'flex flex-col w-full gap-4'}>
          <Skeleton className="w-full h-8" />
          <Skeleton className="w-full h-8" />
          <Skeleton className="w-full h-8" />
        </div>
      );
    }

    if (isV2 && isCustomSettings) {
      return <CustomConfigurationMessage className="w-full" />;
    }

    return <KnowledgeBases />;
  };

  return (
    <CardContainer className="h-full flex-1">
      <div
        className={clsx(
          (!currentProject?.is_active || isInactivePlan) && 'opacity-30 pointer-events-none',
          'card-header z-50',
        )}
      >
        <div className="title cursor-default">
          <span className="!no-underline max-md:hidden text-sm font-bold text-[#7A6BE5]">
            Assigned Knowledge Bases
          </span>
        </div>
      </div>
      <div
        className={clsx(
          (!currentProject?.is_active || isInactivePlan) && 'opacity-30 pointer-events-none',
          'card-body flex w-full gap-2.5 max-md:flex-col !mt-2.5',
        )}
      >
        {renderContent()}
      </div>
    </CardContainer>
  );
};
